import { CircularProgress, EmptyState, InfiniteScrollTrigger, SidePanel, Stack } from '@all-manager/design-system-v2';
import { ReminderDatabase } from "../../../../types";
import ReminderCard from "../../../providers/components/ProviderDetails/ReminderCard/ReminderCard";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  reminders: ReminderDatabase[];
  hasMore: boolean;
  isLoading: boolean;
  isLoadingMore: boolean;
  isLoadMoreError: boolean;
  onLoadMore: () => void;
};

export default function UpcomingRemindersDrawer(props: Props) {
  const isFirstLoad = props.isLoading && props.reminders.length === 0;

  return (
    <SidePanel
      open={props.isOpen}
      onClose={props.onClose}
      closeLabel="Fermer les rappels à venir"
      title="Rappels à venir"
    >
      {isFirstLoad ? (
        <Stack alignItems="center">
          <CircularProgress size="small" aria-label="Chargement des rappels" />
        </Stack>
      ) : props.reminders.length === 0 ? (
        <EmptyState
          title="Aucun rappel à venir"
          subtitle="Les rappels créés sur les sujets et les prestataires apparaîtront ici, par date d'échéance."
        />
      ) : (
        <Stack spacing={1}>
          {props.reminders.map((reminder) => (
            <ReminderCard
              key={reminder.id}
              reminder={reminder}
              displayProvider
              displaySubject
            />
          ))}
          <InfiniteScrollTrigger
            hasMore={props.hasMore}
            isLoading={props.isLoadingMore}
            isError={props.isLoadMoreError}
            onLoadMore={props.onLoadMore}
          />
        </Stack>
      )}
    </SidePanel>
  );
}
